import CONCILIATED_ACTIONS from "./conciliated";
import PENDING_ACTIONS from "./pending";
import USER_ACTIONS from "./user";
import FILE_ACTIONS from "./files";
import CLIENT_ACTIONS from "./client";
import MESSAGES_ACTIONS from "./messages";
import AUTOMATIC_ACTIONS from "./automatic";
import DETAIL_ACTIONS from "./detail";

export const CONCILIATED = CONCILIATED_ACTIONS;
export const PENDING = PENDING_ACTIONS;
export const USER = USER_ACTIONS;
export const FILE = FILE_ACTIONS;
export const CLIENT = CLIENT_ACTIONS;
export const MESSAGES = MESSAGES_ACTIONS;
export const AUTOMATIC = AUTOMATIC_ACTIONS;
export const DETAIL = DETAIL_ACTIONS;

export default { CONCILIATED, PENDING, USER, FILE, CLIENT, AUTOMATIC, DETAIL };
